<template>
  <div id="Company">
    <!-- Comapany -->
    <div class="settings_view">
      <div class="default_top">
        <div>
          <span>Company</span>
        </div>
        <div>
          <button class="main_btn" v-if="company_edit == false" @click="company_edit = true">Edit</button>
          <button class="save_btn" v-if="company_edit == true" @click="company_edit = false">Save</button>
          <button
            class="delete_btn"
            v-if="company_edit == true"
            @click="company_edit = false"
          >Cancel</button>
        </div>
      </div>

      <div class="content_account">
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Account Id :</span>
          </div>
          <div class="col-9">
            <input type="text" value="#3245678654" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Company ID / UEN :</span>
          </div>
          <div class="col-9">
            <input type="text" value="#CDD56F6TUYG687FY" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Full Name :</span>
          </div>
          <div class="col-9">
            <input type="text" value="Microsoft Pvt Ltd" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Address :</span>
          </div>
          <div class="col-9">
            <input type="text" value="One Microsoft Way" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">City :</span>
          </div>
          <div class="col-9">
            <input type="text" value="Redmond" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">State :</span>
          </div>
          <div class="col-9">
            <input type="text" value="Redmond" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Country :</span>
          </div>
          <div class="col-9">
            <input type="text" value="USA" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">PIN :</span>
          </div>
          <div class="col-9">
            <input type="text" value="23423" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Phone number :</span>
          </div>
          <div class="col-9">
            <input type="text" value="+1-202-555-0135" :disabled="company_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Website :</span>
          </div>
          <div class="col-9">
            <input type="text" value="www.microsoft.com" :disabled="company_edit == false" />
          </div>
        </div>
      </div>
    </div>
    <!-- Billing contact -->
    <div class="settings_view">
      <div class="default_top">
        <div>
          <span>Billing contact</span>
        </div>
        <div>
          <button class="main_btn" v-if="billing_edit == false" @click="billing_edit = true">Edit</button>
          <button class="save_btn" v-if="billing_edit == true" @click="billing_edit = false">Save</button>
          <button
            class="delete_btn"
            v-if="billing_edit == true"
            @click="billing_edit = false"
          >Cancel</button>
        </div>
      </div>

      <div class="content_account">
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Name :</span>
          </div>
          <div class="col-9">
            <input type="text" value="Joseph Davis" :disabled="billing_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Email :</span>
          </div>
          <div class="col-9">
            <input type="text" value="joseph@gmail.com" :disabled="billing_edit == false" />
          </div>
        </div>
        <div class="section">
          <div class="col-3 text-right">
            <span class="title">Phone number :</span>
          </div>
          <div class="col-9">
            <input type="text" value="+1-202-555-0135" :disabled="billing_edit == false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Company",
  components: {},
  data() {
    return {
      company_edit: false,
      billing_edit: false
    };
  },
  methods: {}
};
</script>
